import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'

import currentUser from './current-user/slice'
import banner from '../features/content/stores/banner/slice'
import benefit from '../features/content/stores/benefit/slice'
import faq from '../features/content/stores/faq/slice'
import pageContent from '../features/content/stores/pageContent/slice'
import popup from '../features/content/stores/popup/slice'
import plan from '../features/insurance/stores/plan/slice'
import product from '../features/content/stores/product/slice'
import masterData from '../features/master-data/stores/slice'
import language from './language/slice'
import user from '../features/user/stores/user/slice'
import role from '../features/user/stores/role/slice'
import customer from '../features/customer/stores/slice'
import insurer from '../features/insurance/stores/insurer/slice'
import dealerMaster from '../features/dealer-master/stores/dealer-master/slice'
import transaction from '../features/transaction/stores/slice'
import promotion from '../features/promotion/stores/slice'
import commission from '../features/dealer-master/stores/commission/slice'

export const createStore = () =>
  configureStore({
    reducer: {
      masterData,
      currentUser,
      user,
      role,
      banner,
      benefit,
      faq,
      pageContent,
      popup,
      product,
      insurer,
      customer,
      dealerMaster,
      language,
      plan,
      transaction,
      promotion,
      commission
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
  })

export const store = createStore()

export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>
